import {remCalc} from '_themeUtils'

const sortByWrapper = {
    SortByWrapper: {
        baseStyle: () => ({
            wrapper: {
                w: {base: '50%', md: 'fit-content'},
                h: {base: remCalc(64), md: 'auto'},
                alignItems: 'center',
                justifyContent: 'center',
                background: 'color.background.white',
                border: {base: '1px solid', md: 'none'},
                borderColor: 'color.border.grey.200',
                gap: {base: 'spacing.2', md: 0},
                p: {
                    color: {base: 'color.text.black', md: 'color.text.grey.600'},
                    textStyle: 'paragraphXs',
                    letterSpacing: {base: remCalc(2), md: remCalc(3)},
                    fontWeight: 400,
                },
            },
        }),
    },
}

export default sortByWrapper
